
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const PrivacyPolicy = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "privacy-policy" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Privacy Policy
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}

                    <div className="cms_content_text">
                        <p className="ql-align-center"><strong>PRIVACY POLICY</strong></p>
                        <p className="ql-align-center"><strong>&nbsp;</strong></p>
                        <p>At Millionaire11, we prioritize your privacy and are committed to safeguarding your personal information. By accessing our platform and participating in contests, you agree to the terms outlined in this Privacy Policy.</p>
                        <p>All capitalized terms not defined here shall have the meaning ascribed to them in our Terms.</p>
                        <p><br /></p>
                        <p><strong>1. Information Collection</strong></p>
                        <p><strong>We collect information to enhance your experience and provide our services efficiently. This includes:</strong></p>
                        <p><br /></p>
                        <p><strong>A. Information Provided by Users</strong></p>
                        <ul>
                            <li>Username</li>
                            <li>Email address</li>
                            <li>Date of birth</li>
                            <li>State</li>
                            <li>Government-issued ID (Aadhaar, driving license, or voter ID)</li>
                        </ul>
                        <p><br /></p>
                        <p><strong>B. Automatically Collected Information</strong></p>
                        <ul>
                            <li>Device information</li>
                            <li>Operating system details</li>
                            <li>Network information</li>
                            <li>Location data</li>
                        </ul>
                        <p>We may also collect sensitive personal information, such as payment details, necessary for transactions. However, we do not store financial information beyond what is required for processing payments.</p>
                        <p><br /></p>
                        <p><strong>2. Purpose and Usage of Information</strong></p>
                        <p><strong>The collected information is used to:</strong></p>
                        <ol>
                            <li>Operate, provide, and enhance our services.</li>
                            <li>Notify you about offers, updates, and relevant promotions.</li>
                            <li>Enable communication from affiliates for promotional purposes.</li>
                        </ol>
                        <p><br /></p>
                        <p><strong>3. Information Sharing &amp; Disclosure</strong></p>
                        <p><strong>Your information may be shared with:</strong></p>
                        <ul>
                            <li><strong>Affiliates and third-party service providers</strong> for data analytics, service improvements, and compliance with legal requirements.</li>
                            <li><strong>Commercial partners</strong> for marketing and promotional activities, with strict confidentiality agreements in place.</li>
                        </ul>
                        <p>By using our platform, you consent to such disclosures and transfers.</p>
                        <p><br /></p>
                        <p><strong>4. Use of Cookies</strong></p>
                        <p><strong>We utilize cookies and similar technologies to:</strong></p>
                        <ul>
                            <li>Track user preferences and improve navigation.</li>
                            <li>Deliver personalized content and advertisements.</li>
                            <li>Analyze traffic and understand user behavior.</li>
                        </ul>
                        <p>You may disable cookies in your browser settings, but this may affect certain functionalities.</p>
                        <p><br /></p>
                        <p><strong>5. Security Measures</strong></p>
                        <p><strong>We implement industry-standard security practices, including:</strong></p>
                        <ul>
                            <li>Secure server storage.</li>
                            <li>Password-protected access controls.</li>
                        </ul>
                        <p>Despite our best efforts, no system is entirely secure. Your information may be transferred and stored outside India, where data protection laws may vary.</p>
                        <p><br /></p>
                        <p><strong>6. Advertising &amp; Analytics</strong></p>
                        <p><strong>We may share aggregated, anonymized data with advertisers to analyze audience behavior. This does not include personal identifiers unless explicitly consented to.</strong></p>
                        <p><br /></p>
                        <p><strong>7. Data Retention</strong></p>
                        <p><strong>Your data is retained as long as:</strong></p>
                        <ol>
                            <li>It serves the purposes outlined in this Privacy Policy.</li>
                            <li>It is required by law or legitimate business interests.</li>
                        </ol>
                        <p>&nbsp;</p>
                        <p><strong>8. User Rights: Account &amp; Data Deletion</strong></p>
                        <p><strong>You can request account deletion or data removal through Help &amp; Support. Upon request:</strong></p>
                        <ul>
                            <li>Your data will be permanently deleted or anonymized within <strong>30 days</strong>.</li>
                            <li>Necessary backups may be retained for legal or operational reasons.</li>
                        </ul>
                        <p>&nbsp;</p>
                        <p><strong>9. Governing Law &amp; Jurisdiction</strong></p>
                        <p><strong>This Privacy Policy is governed by the laws of India</strong>, and any disputes are subject to the jurisdiction outlined in our Terms.</p>
                        <p><br /></p>
                        <p><strong>10. Updating Your Information</strong></p>
                        <p><strong>You are responsible for keeping your information updated. Changes can be made through your account settings.</strong></p>
                        <p><strong>&nbsp;</strong></p>
                        <p><strong>&nbsp;</strong></p>
                        <p><strong>Contact Us</strong></p>
                        <p><strong>&nbsp;</strong></p>
                        <p><strong>For any privacy-related concerns, please reach out to our Help &amp; Support team.</strong></p>
                        <p><strong>Thank you for trusting us with your information!</strong></p>
                        <p><strong>&nbsp;</strong></p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy